import { useState, useCallback, ChangeEvent } from 'react';
import { useFormik } from 'formik';
import { PasswordResetForm } from 'models';

import services from 'services';
import _set from 'lodash/set';

import { PasswordResetView } from 'components';

interface LocalState {
  loading: boolean;
  error: boolean;
  isSuccess: boolean;
  errorMessage: string | null;
  description: string;
}

const PasswordReset = () => {
  const [state, setState] = useState<LocalState>({
    loading: false,
    error: false,
    isSuccess: false,
    errorMessage: null,
    description: '',
  });
  const formik = useFormik({
    validateOnMount: false,
    validateOnBlur: false,
    validateOnChange: false,
    initialValues: {
      email: '',
    } as PasswordResetForm,
    validate: (values) => {
      let errors = {};
      const emailPattern = new RegExp(
        /^[a-z0-9._%+-]+\@([a-z0-9.-])+\.([a-z]{2,})$/g
      );

      const required = 'Lisää puuttuva tieto';
      const invalidPattern = 'Syötä tieto oikeassa muodossa';

      if (!values.email) {
        _set(errors, 'email', required);
      }

      if (values.email) {
        if (!emailPattern.test(values.email)) {
          _set(errors, 'email', invalidPattern);
          return errors;
        }
      }

      return errors;
    },
    onSubmit: async (values) => {
      try {
        setState((prevState) => ({ ...prevState, loading: true }));

        let errorMessage: string | null = null;

        const res = await services.post('/api/password/reset', {
          Email: values.email,
        });

        if (res.status !== 202 && res.status !== 201) {
          errorMessage = res.data.Data[0].ErrorMessage as string;
        }

        setState((prevState) => ({
          ...prevState,
          isSuccess: !!!errorMessage,
          loading: false,
          errorMessage,
          description: res.data.Data ?? '',
        }));
      } catch (err) {
        console.error(err);

        setState((prevState) => ({
          ...prevState,
          loading: false,
          error: true,
        }));
      }
    },
  });

  const handleChangeInput = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { name, value } = e.target;

      formik.setFieldValue(name, value);
    },
    [formik]
  );

  const handleInitErrors = useCallback(() => {
    formik.setErrors({});
  }, [formik]);

  const handleSubmit = useCallback(() => {
    formik.handleSubmit();
  }, [formik]);

  return (
    <PasswordResetView
      {...state}
      values={formik.values}
      errors={formik.errors}
      handleChangeInput={handleChangeInput}
      handleInitErrors={handleInitErrors}
      handleSubmit={handleSubmit}
    />
  );
};

export default PasswordReset;
